export class DialogData {
  constructor(
    title: string,
    content: string,
    okButtonText: string = 'Okay',
    cancelButtonText: string = 'No Thanks'
  ) {
    this.title = title;
    this.content = content;
    this.okButtonsName = okButtonText;
    this.cancelButtonsName = cancelButtonText;
  }

  title: string;
  content: string;
  okButtonsName: string;
  cancelButtonsName: string;
}
